import { gql } from "@apollo/client"
import { Callout } from "@oysterhr/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import type { Agreement, Hiring, Maybe } from "@oysterhr/schema"

export const RegenerationInfoAlert = ({
  className,
  hiring,
}: {
  className: string
  hiring: Maybe<HiringFTECompanyRegenerationInfoAlertFragment> | undefined
}): JSX.Element => {
  const { t } = useTranslation("hiring_fte/RegenerationInfoAlert")
  const [isOpen, setIsOpen] = useState(true)

  const isAutomated = Boolean(hiring?.agreements?.filter(agg => agg.isAutomated)?.length)

  return (
    <>
      {isOpen && (
        <div className={className}>
          <Callout
            variation="info"
            onRequestClose={() => {
              setIsOpen(false)
            }}
          >
            <Callout.Heading>
              {isAutomated ? t("automated.title") : t("manual.title")}
            </Callout.Heading>
            <Callout.Content>
              {isAutomated ? t("automated.description") : t("manual.description")}
            </Callout.Content>
          </Callout>
        </div>
      )}
    </>
  )
}

RegenerationInfoAlert.fragments = {
  hiring: gql`
    fragment HiringFTECompanyRegenerationInfoAlertFragment on Hiring {
      id
      agreements {
        id
        isAutomated
      }
    }
  `,
}

export type HiringFTECompanyRegenerationInfoAlertFragment = Pick<Hiring, "id"> & {
  agreements: Pick<Agreement, "id" | "agreementType" | "isAutomated">[]
}
